import { useHashToToggleModal } from '../../composables/useHashToToggleModal'
import Modal from '../Modal/Modal.vue'

export default {
    name: 'LegalText',
    components: {
        Modal,
    },
    props: {
        juraModal: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { isOpen, close, title, body } = useHashToToggleModal([props.juraModal])

        return {
            isOpen,
            title,
            body,
            close,
        }
    },
}
